import { FaCheck, FaMinus } from "react-icons/fa";
import { GiReturnArrow } from "react-icons/gi";
import { Container, Table, Button, Spinner } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from "react";
import { LastPositionContext } from "../../services/ClienteContext";
import NotificationsAlert from "../../services/NotificationsAlert";
import { useNavigate } from "react-router-dom";
import Conect from "../../../Api/Conect";
import moment from "moment/moment";
import './VehiclePositionTable.css';


const LastPosition = () => {
    const data = useContext(LastPositionContext);
    const history = useNavigate();

    const token = localStorage.getItem("restoken")
    const fusoUser = localStorage.getItem('resstateFuso')
    const id_cli = localStorage.getItem('resid_cli')

    const [msg, setMsg] = useState(null)
    const [cliData, setCliData] = useState(null)
    const [load, setLoad] = useState(false)
    const [positions, setPositions] = useState([])


    useEffect(() => {
        if (token === null) {
            NotificationsAlert("warning", "Desconectado", "Faça login para continuar!")
            history("/login");
        } else {
            setLoad(true)
            getLast()
            getCliInfos()
        }
        // eslint-disable-next-line
    }, []);

    const getLast = async () => {
        if (data.posiData == null) {
            history("/home");
            setLoad(false)
            return
        }

        const DT_INICIAL = moment().format("YYYY-MM-DD");
        let hrInicial = "03:00:00";
        let hrFinal = "23:59:59";
        let dtFinal = moment().add(1, "day").format("YYYY-MM-DD");


        const response = await Conect.post(`/b2xkcG9zaXRpb25z${token}`, {
            id: data.posiData.idVehicle,
            startDate: `${DT_INICIAL} ${hrInicial}`,
            endDate: `${dtFinal} ${hrFinal}`
        })

        // eslint-disable-next-line
        if (response.data.erro === true) {
            NotificationsAlert("warning", "Atenção", response.data.msg)
        }
        if (response.data.msg) {
            setLoad(false)
            setMsg(response.data.msg)
        }
        else {
            let dados = response.data.vehiclePosition.map((value, index) => {
                let link = `https://www.google.com.br/maps/place/${value.latitude},${value.longitude}`
                return (<tr style={{ color: "#fff", fontSize: 14 }} key={index}>
                    <td>{index + 1}</td>
                    <td>{value.plate}</td>
                    <td>{`${moment(value.dateTime).subtract(Math.abs(fusoUser), "hours").format("DD/MM/yyyy")} - ${moment(value.dateTime).subtract(Math.abs(fusoUser), "hours").format("HH:mm:ss")}`}</td>
                    <td>{value.nearDesc}</td>
                    <td>{value.speed.toFixed(0)} Km/h</td>
                    <td>{String(value.odometerGps / 1000).substring(0, 7)}</td>
                    <td>{value.extPower} V</td>
                    <td>{value.ignition === 1 ?
                        <FaCheck style={{ marginLeft: 5, fontSize: 25, color: '#0f0' }} />
                        :
                        <FaMinus style={{ marginLeft: 5, fontSize: 25, color: '#f00' }} />
                    }
                    </td>
                    <td>{value.output2 === 1 ?
                        <FaCheck style={{ marginLeft: 5, fontSize: 25, color: '#0f0' }} />
                        :
                        <FaMinus style={{ marginLeft: 5, fontSize: 25, color: '#f00' }} />
                    }
                    </td>
                    <td>
                        <a href={link}>
                            {value.latitude.toFixed(3)}/{value.longitude.toFixed(3)}
                        </a>
                    </td>
                </tr>)
            })
            setLoad(false)
            setPositions(dados)
            // eslint-disable-next-line
        }
    }

    const getCliInfos = async () => {
        const response = await Conect.post(`/aW5mb2NsaWVudGU=${token}`, {
            id: id_cli
        })
        // eslint-disable-next-line
        if (response.data.erro === true) {
            NotificationsAlert("warning", "Atenção", response.data.msg)
        }
        else {
            setCliData(response.data.data)
            // eslint-disable-next-line
        }
    }

    return (
        <>
            {cliData != null &&
                <p className="list-info-cli-last-posi">
                    <div style={{ textAlign: 'center', width: '100%' }}>
                        <strong>Cliente: </strong>{cliData.name}
                        <strong style={{ marginLeft: "5%" }}>Veiculo: </strong>{data.posiData.plate}
                    </div>
                    <Button style={{ position: "absolute", borderTopRightRadius: "20px" }} onClick={() => history("/home")} className="btn-action-last-posi">
                        <GiReturnArrow className="icon-btn-last-posi" />
                    </Button>
                </p>
            }
            {
                load &&
                <div style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                    <Spinner
                        style={{ color: "#fff" }}
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <strong style={{ marginLeft: "2px", color: "#fff" }}>
                        Loading...
                    </strong>
                </div>
            }
            {
                positions.length > 0 ?
                    <Container>
                        <div style={{
                            width: "100%",
                            overflowX: 'hidden'
                        }}>

                            <Table className="vehicle-table" responsive>
                                <thead style={{ fontSize: 14 }}>
                                    <tr style={{ color: '#fff' }}>
                                        <th>#</th>
                                        <th>Placa</th>
                                        <th>Data e Hora</th>
                                        <th>Localização</th>
                                        <th>Velocidade</th>
                                        <th>Hodometro</th>
                                        <th>Ext Power</th>
                                        <th>Ignição</th>
                                        <th>Bloqueio</th>
                                        <th>Localização</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {positions}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                    :
                    msg != null &&
                    <h3 className="list-info-cli">{msg}</h3>
            }


        </>
    )
}

export default LastPosition;